(function () {
  function init() {
    const bar = document.querySelector('.sticky-bar');
    if (!bar) return;
    const trigger = document.querySelector('.hero');
    if (!trigger) return;

    let visible = false;
    function update() {
      const r = trigger.getBoundingClientRect();
      const shouldShow = r.bottom < 240;
      if (shouldShow !== visible) {
        visible = shouldShow;
        bar.classList.toggle('is-visible', visible);
      }
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
